var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalyseCommentIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon analyse-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF8000",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M10 1a8.972 8.972 0 016.364 2.636A8.972 8.972 0 0119 10a8.972 8.972 0 01-2.636 6.364A8.972 8.972 0 0110 19a8.972 8.972 0 01-6.364-2.636A8.972 8.972 0 011 10a8.972 8.972 0 012.636-6.364A8.972 8.972 0 0110 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.342 5.537a1 1 0 01.545.48l.05.115 2.517 6.86a.75.75 0 01-1.367.61l-.041-.094-.462-1.258h-3.17l-.46 1.258a.75.75 0 01-.864.475l-.098-.029a.75.75 0 01-.475-.864l.029-.098 2.513-6.86a1 1 0 011.283-.595zM9.998 7.93l-1.034 2.82h2.07L9.998 7.93z"
  }))));
}

export default SvgAnalyseCommentIconSv;